const initialState = {
  scenarios: [],
  isLoadingScenarios: false,

  isLoadingUpdateReportValue: false,
  isLoadingResetReportValue: false,
};

export default initialState;
